import { jsx as _jsx } from "react/jsx-runtime";
import { HORIZONTAL_SCROLL_ITEM_IDENTIFIER_ATTRIBUTE } from '../constants';
import { useHorizontalScrollContext } from '../provider/HorizontalScrollContext';
import { HorizontalScrollItemContainer } from '../styles/horizontal-scroll-item.styled';
const HorizontalScrollItem = ({ children, dataTest = 'item' }) => {
    const { dataTest: parentDataTest } = useHorizontalScrollContext();
    return (_jsx(HorizontalScrollItemContainer, { "data-test": `${parentDataTest}-${dataTest}`, [HORIZONTAL_SCROLL_ITEM_IDENTIFIER_ATTRIBUTE]: true, children: children }));
};
HorizontalScrollItem.HORIZONTAL_SCROLL_ELEMENT = 'HORIZONTAL_SCROLL_ITEM';
HorizontalScrollItem.displayName = 'SwiperSlide';
export default HorizontalScrollItem;
